import { jsx as _jsx } from "react/jsx-runtime";
/**
 * 应用切换器快照遮盖层。
 *
 * 威胁模型：拿到这台已解锁手机的人**一划多任务**就看见了联系人、消息、图片——
 * 连解锁都不用。应用锁挡不住这一层：它挡的是重新进入，不是系统在切后台那一刻截的那张图。
 *
 * ⚠️ **这一条降低概率，不消除风险。** iOS 上截图时机不由网页决定，系统完全可能在
 * `visibilitychange` 派发之前就截了。文档、界面文案里都不许写"防止"——
 * 对这个威胁模型的用户来说，让他据此做出他不该做的判断就是实际伤害。
 */
import { createPortal } from 'react-dom';
import {} from 'react';
import { useBackgrounded } from '@pwaship/react';
export function BackdropCover({ children, enabled = true, className = '' }) {
    const backgrounded = useBackgrounded();
    if (!enabled || !backgrounded || typeof document === 'undefined')
        return null;
    // ⚠️ 必须挂到 body 上。留在组件树里的话，任何一个开了 transform / filter / contain 的
    // 祖先都会把它困在自己的层叠上下文里——那时候它盖住的是半个界面，而你在开发机上
    // 永远看不到（开发机不切后台）。
    return createPortal(_jsx("div", { className: `ps-backdrop-cover ${className}`.trim(), "aria-hidden": "true", role: "presentation", children: children }), document.body);
}
//# sourceMappingURL=backdrop-cover.js.map